import styled, { AnyStyledComponent, css } from 'styled-components';
import { Fonts, Spinner } from '@bimone/bimtrackreactcomponents';

export const StyledLoadingContent = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${({ theme: { colors, metrics } }) => css`
      background: ${colors.white};

      & ${(): AnyStyledComponent => StyledLoadingContent.Title} {
        margin-bottom: ${metrics.rem(16)};
      }
    `};
  `,
  Title: styled.h3`
    text-align: center;
    ${({ theme: { colors, fonts } }) => css`
      ${fonts.sub({ fontFamily: Fonts.family.BOOK, color: colors.grey.darker })};
    `}
  `,
  Message: styled.div`
    text-align: center;
    ${({ theme: { colors, fonts } }) => css`
      ${fonts.small({ fontFamily: Fonts.family.BOOK, color: colors.grey.darker })};
    `}
  `,
  Spinner: Spinner,
};
